import { createSelector } from '@reduxjs/toolkit';
import { sortStatusEntries } from './util.sort.js';

const selectSortedStatusEntries = createSelector(state => state.sortedBy, state => state.direction, (state, entries) => entries, (sortedBy, direction, entries) => sortStatusEntries(entries, sortedBy, direction));

export { selectSortedStatusEntries };
//# sourceMappingURL=state.selectors.js.map
